import { setCookie } from 'cookies-next';
import { useRouter } from 'next/router';

import { FRONTEND_DOMAIN } from 'utils/env.utils';
import { getDefaultLocale, getLocale } from 'utils/i18n.utils';

const frontendUrl = new URL(FRONTEND_DOMAIN);

export const useLocale = () => {
  const router = useRouter();

  const updateLocale = (locale: string) => {
    const today = new Date();
    today.setDate(today.getDate() + 7);
    setCookie('NEXT_LOCALE', locale, {
      sameSite: 'none',
      path: '/',
      secure: true,
      expires: today,
      domain: frontendUrl.hostname,
    });
  };

  return {
    locale: getLocale(router),
    defaultLocale: getDefaultLocale(router),
    updateLocale,
  };
};
